import React, {Component} from 'react';
import axios from 'axios';
import {Card, CardBody, CardHeader} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import {FaUsers} from "react-icons/fa";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class InfoCustomerPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            error: false,
            messageError: '',
            user: {},
            name: "",
            avatar: "",
            email: "",
            date: "",
            gender: "",
            address: "",
            phone: "",
            btnSubmit: false,
            errorForm: false,
            messageErrorForm: '',
            successForm: false,
            messageSuccessForm: '',
            file: null,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getInfoUser();
    }

    getInfoUser = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/home/getInfoUser',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data.content.info.date);
                if ( ref.data.error === 0 ) {
                    let date = new Date();
                    if ( ref.data.content.info.date ) {
                        date = new Date(ref.data.content.info.date);
                    }
                    this.setState({
                        user: ref.data.content,
                        name: ref.data.content.info.name,
                        email: ref.data.content.info.email,
                        date: date,
                        gender: ref.data.content.info.gender ? ref.data.content.info.gender : 'nam',
                        address: ref.data.content.info.address ? ref.data.content.info.address : '',
                        phone: ref.data.content.info.phone ? ref.data.content.info.phone : '',
                        avatar: ref.data.content.info.avatar ? ref.data.content.info.avatar : '',
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value
        })
    }

    changeAvatar = event => {
        let value = event.target.files[0];
        this.setState({
            file: value,
            avatar: URL.createObjectURL(event.target.files[0])
        })
    }

    setDate = (date) => {
        this.setState({
            date: date
        })
    }

    submit = () => {
        this.setState({
            btnSubmit: true
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let formData = new FormData()
            // console.log(this.formatDateDatabase(this.state.date))
            formData.append('avatar', this.state.file ? this.state.file : 0);
            formData.append('name', this.state.name);
            formData.append('phone', this.state.phone);
            formData.append('address', this.state.address);
            formData.append('date', this.formatDateDatabase(this.state.date));
            formData.append('gender', this.state.gender);

            axios.post( process.env.REACT_APP_API_URL + '/api/home/updateInfoUser', formData,
                {
                    headers: {
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth),
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then( (ref) => {
                    console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        //avatar
                        let user = this.state.user;
                        user.info.avatar = ref.data.user.avatar;
                        // ngày sinh
                        let date = new Date();
                        if ( ref.data.content.date ) {
                            date = new Date(ref.data.content.date);
                        }

                        this.setState({
                            errorForm: false,
                            messageErrorForm: '',
                            loadPage: false,
                            isLoading: false,
                            successForm: true,
                            messageSuccessForm: ref.data.message,
                            btnSubmit: false,
                            name: ref.data.content.name,
                            email: ref.data.content.email,
                            date: date,
                            gender: ref.data.content.gender ? ref.data.content.gender : 'nam',
                            address: ref.data.content.address ? ref.data.content.address : '',
                            phone: ref.data.content.phone ? ref.data.content.phone : '',
                            user: user
                        })

                        let menu = 'user';
                        let sessionRole = 'user';

                        let itemUser = {
                            user: ref.data.user,
                            menu: menu,
                            sessionRole: sessionRole
                        }
                        this.props.saveUser(itemUser);
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                                loadPage: false,
                                isLoading: false,
                                successForm: false,
                                messageSuccessForm: '',
                                btnSubmit: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        loadPage: false,
                        isLoading: false,
                        errorForm: true,
                        messageErrorForm: 'Cập nhật dữ liệu thất bại',
                        successForm: false,
                        messageSuccessForm: '',
                        btnSubmit: false,
                    })
                })
        }
    }

    validate = () => {
        if ( this.state.name.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Họ và tên không được để trống',
                btnSubmit: false,
            })
        }
        else if ( this.state.date.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Ngày sinh không được để trống',
                btnSubmit: false,
            })
        }
        else if ( this.state.address.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Địa chỉ không được để trống',
                btnSubmit: false,
            })
        }
        else if ( this.state.gender.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Giới tính không được để trống',
                btnSubmit: false,
            })
        }
        else if ( this.state.phone.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Số điện thoại không được để trống',
                btnSubmit: false,
            })
        }
        return true;
    }

    formatDateDatabase = (date) => {
        var formatDate = new Date(date);
        var day = formatDate.getDate();
        if (day < 10) {
            day = '0' + day;
        }
        var month = date.getMonth() + 1;
        if (month < 10) {
            month = '0' + month;
        }
        return date.getFullYear()  + '-' + month + '-' + day;
    }



    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Thông tin tài khoản"} page={"Tài khoản"} icon={<FaUsers className="breadcrumb-icon"/>} />
                            <div className="row">
                                {
                                    this.state.error ? (
                                        <Alert color="danger">
                                            { this.state.messageError }
                                        </Alert>
                                    ) : (
                                        <>
                                            {
                                                this.state.errorForm ? (
                                                    <div className="col-md-12">
                                                        <Alert color="danger">
                                                            { this.state.messageErrorForm }
                                                        </Alert>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            {
                                                this.state.successForm ? (
                                                    <div className="col-md-12">
                                                        <Alert color="success">
                                                            { this.state.messageSuccessForm }
                                                        </Alert>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            <div className="col-md-4">
                                                <Card>
                                                    <CardHeader>
                                                        <h4 className="card-title title-services">
                                                            Thông tin tài khoản
                                                        </h4>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <p><strong>Tổng dịch vụ: </strong>{ this.state.user.service.total }</p>
                                                        {
                                                            this.state.user.service.vps ? (
                                                                <p><strong>VPS: </strong>{ this.state.user.service.total_vps }</p>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        {
                                                            this.state.user.service.cloud_server ? (
                                                                <p><strong>Cloud Server: </strong>{ this.state.user.service.total_cloud_server }</p>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        {
                                                            this.state.user.service.hosting ? (
                                                                <p><strong>Hosting: </strong>{ this.state.user.service.total_hosting }</p>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                        <p><strong>Số dư tài khoản: </strong><strong className="text-danger">{ this.addCommas( this.state.user.credit.credit ) } ₫</strong></p>
                                                        <p><strong>Tổng tiền đã chi: </strong><strong className="text-danger">{ this.addCommas( this.state.user.credit.total_total_expenses ) } ₫</strong></p>
                                                        <p><strong>Tổng tiền đã nạp: </strong><strong className="text-danger">{ this.addCommas( this.state.user.credit.total ) } ₫</strong></p>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                            <div className="col-md-8">
                                                <Card>
                                                    <CardHeader>
                                                        <h4 className="card-title title-services">
                                                            Thông tin tài khoản
                                                        </h4>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <div className="form-group mb-5 mt-3">
                                                            <div className="profile-avatar text-center mb-4">
                                                                <img src={ this.state.avatar } alt="Avatar Customer" width="auto" style={{ 'maxHeight': 100, 'maxWidth': 200 }} />
                                                            </div>
                                                            <div className="update-avatar custom-file text-center">
                                                                <input type="file" id="validatedCustomFile" name="avatar" placeholder="Cập nhật avatar" onChange={ this.changeAvatar } />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col-xl-6 col-lg-12 mb-4">
                                                                <label htmlFor="name">Họ và tên</label>
                                                                <input type="text" id="name" name="name" value={ this.state.name } className="form-control" onChange={ this.changeInput } />
                                                            </div>
                                                            <div className="col-xl-6 col-lg-12 mb-4">
                                                                <label htmlFor="email">Email</label>
                                                                <input type="email" id="email" disabled={true} name="email" value={ this.state.email } className="form-control" onChange={ this.changeInput } />
                                                            </div>
                                                            <div className="col-xl-6 col-lg-12 mb-4">
                                                                <label htmlFor="phone">Số điện thoại</label>
                                                                <input type="text" id="phone" name="phone" value={ this.state.phone } className="form-control" onChange={ this.changeInput } />
                                                            </div>
                                                            <div className="col-xl-6 col-lg-12 mb-4">
                                                                <label htmlFor="date">Ngày sinh</label>
                                                                {/*<input type="text" id="date" name="date" value={ this.state.date } className="form-control" onChange={ this.changeInput } />*/}
                                                                <DatePicker
                                                                    selected={this.state.date}
                                                                    onChange={(date) => this.setDate(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-xl-6 col-lg-12 mb-4">
                                                                <label htmlFor="gender">Giới tính</label>
                                                                <select name="gender" id="gender" value={ this.state.gender } className="form-control" onChange={ this.changeInput }>
                                                                    <option value="nam">Nam</option>
                                                                    <option value="nữ">Nữ</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-12 mb-4">
                                                                <label htmlFor="address">Địa chỉ</label>
                                                                <input type="text" id="address" name="address" value={ this.state.address } className="form-control" onChange={ this.changeInput } />
                                                            </div>
                                                        </div>
                                                        <div className="form-group text-right">
                                                            <button className="btn btn-sm btn-primary" onClick={ () => this.submit() } disabled={this.state.btnSubmit}>Cập nhật</button>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerInfo' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        saveUser: (item) => {
            dispatch(({ type : 'saveUser', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(InfoCustomerPage);